import { X } from 'lucide-react';
import { useAssistantStore } from '../store/assistant-store';

export function ContextChip() {
  const { recordContext, contextDismissed, dismissContext } =
    useAssistantStore();
  if (!recordContext || contextDismissed) return null;
  return (
    <div
      className='mx-3 mb-2 flex items-center gap-2 self-start rounded-full border border-primary-200
                    bg-primary-50 px-3 py-1 text-xs text-primary-1000'
    >
      <span className='font-medium'>Context:</span>
      <span>{recordContext.label}</span>
      <button
        aria-label='Drop context'
        onClick={dismissContext}
        className='hover:text-primary-700'
      >
        <X className='size-3.5' />
      </button>
    </div>
  );
}
